import store from '../store/index';

export function maxLength(limit) {
  return value => (value && value.length <= limit) || store.state.translations.keys.form_field_maxlength;
}
